// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"b0255e25","150":"df50226b","259":"6171ebd3","268":"8e76a0d3","498":"d798c190","551":"3a43b8bd","849":"55c40661"}[chunkId] + ".chunk.js";
};